import * as Type from './actionsTypes';

const findProgramacaoDiariaDiaById = id => ({
  type: Type.PROGRAMACAO_DIARIA_DIA_FIND_BY_ID,
  id,
});

const saveProgramacaoDiariaDia = (data, callback) => ({
  type: Type.SAVE_PROGRAMACAO_DIARIA_DIA,
  data,
  callback,
});

const updateProgramacaoDiariaDia = (data, callback) => ({
  type: Type.UPDATE_PROGRAMACAO_DIARIA_DIA,
  data,
  callback,
});

const exportProgramacaoDiariaDia = (filter, callbackAfterSave) => ({
  type: Type.PROGRAMACAO_DIARIA_DIA_EXPORT,
  filter,
  callbackAfterSave,
});

const clearProgramacaoDiariaDia = () => ({
  type: Type.CLEAR_PROGRAMACAO_DIARIA_DIA,
});

export {
  findProgramacaoDiariaDiaById,
  saveProgramacaoDiariaDia,
  updateProgramacaoDiariaDia,
  exportProgramacaoDiariaDia,
  clearProgramacaoDiariaDia,
};
